import React                               from 'react';
import { FormView, WithStyle }             from 'rewire-ui';
import { Theme }                           from '@material-ui/core/styles';
import DraggableResizableDialog            from '../ui/DraggableResizableDialog';
import selectEmployeeDialogModel           from './SelectEmployeeDialogModel';
import { withStyles }                      from '../utility/styles';

const styles = (_theme: Theme) => ({
  content: {
    padding: '30px 20px 0 20px',
    overflowY: 'auto',
  },
  fieldContainer: {
    width: '100%',
    marginBottom: '20px',
    '& > div': {
      display: 'flex',
    },
  },
});

interface ISelectEmployeeDialogProps {
}

type SelectEmployeeDialogProps = WithStyle<ReturnType<typeof styles>, ISelectEmployeeDialogProps>;

class SelectEmployeeDialog extends React.PureComponent<SelectEmployeeDialogProps> {

  constructor(props: SelectEmployeeDialogProps) {
    super(props);
  }

  componentWillUnmount() {
    selectEmployeeDialogModel.reset();
  }

  renderDialogContents = React.memo((): JSX.Element => {
    const { classes } = this.props;

    return (
      <FormView form={selectEmployeeDialogModel.form} onSubmit={selectEmployeeDialogModel.actionFn('select')}>
        <div className={classes.content}>
          <div key={'employee'} className={classes.fieldContainer}>
            <selectEmployeeDialogModel.form.field.employee.Editor  />
          </div>
        </div>
      </FormView>
    );
  });

  render() {
    return (
      <DraggableResizableDialog defaultWidth='xs' DialogProps={{dialog: selectEmployeeDialogModel}} DraggableResizableBoxProps={{minWidth: '250px', minHeight: '239px'}}>
        <this.renderDialogContents />
      </DraggableResizableDialog>
    );
  }
}

export default withStyles<ISelectEmployeeDialogProps>(styles, SelectEmployeeDialog);
